(function () {
  angular.module('app').config(configApp);

  /* @ngInject */
  function configApp(
    $compileProvider,
    $httpProvider,
    $qProvider,
    apiInterceptorReadyProvider,
    apiReadyProvider,
    appReadyProvider,
    authenticationReadyProvider,
    configurationReadyProvider,
    featureReadyProvider,
    localeReadyProvider
  ) {
    $httpProvider.interceptors.push('httpInterceptor');
    // Disable error message from Angular 1.6
    // http://www.codelord.net/2017/08/20/angular-1-dot-6-s-possibly-unhandled-rejection-errors/
    $qProvider.errorOnUnhandledRejections(false);
    // https://docs.angularjs.org/guide/migration#migrate1.5to1.6-ng-services-$compile
    $compileProvider.preAssignBindingsEnabled(true);
    // We allow HTTPS, HTTP, BLOB, and email links
    // NOTE: the usage of linky filter requires mailto to be configured in app.config.js $compileProvider.aHrefSanitizationWhitelist
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|blob|mailto):/);

    appReadyProvider.configure(
      apiInterceptorReadyProvider,
      apiReadyProvider,
      authenticationReadyProvider,
      configurationReadyProvider,
      featureReadyProvider,
      localeReadyProvider
    );
  }
})();
